import { render } from "./detailsModalHost.vue?vue&type=template&id=4aeaa980&ts=true"
import script from "./detailsModalHost.vue?vue&type=script&lang=ts"
export * from "./detailsModalHost.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__